import React from 'react';
import {Link, Stack} from '@mui/material';
import {Body, Icon} from '@lightricks/react-design-system';
import {MessageAttachment} from '@/api/messages/types';
import styles from './MessageAttachmentTile.module.scss';

interface Props {
  attachment: MessageAttachment;
}

type IconName = React.ComponentProps<typeof Icon>['name'];

function fileTypeIcon(mimeType: string): IconName {
  if (/^video\//.test(mimeType)) return 'Navigation-VideoCamera-Line';
  if (/^audio\//.test(mimeType)) return 'Features-Audio-On';
  return 'Navigation-Page';
}

export default function MessageAttachmentTile({attachment}: Props) {
  if (attachment.isImage) {
    return (
      <Link
        className={styles.imageTile}
        href={attachment.viewableUrl}
        target="_blank"
        rel="noreferrer"
        data-testid="message-attachment-image"
      >
        <img
          src={attachment.viewableUrl}
          alt={attachment.fileName}
          className={styles.image}
        />
      </Link>
    );
  }

  return (
    <Stack
      component={Link}
      direction="row"
      alignItems="center"
      spacing={1}
      className={styles.fileTile}
      href={attachment.downloadUrl}
      download={attachment.fileName}
      target="_blank"
      rel="noreferrer"
      data-testid="message-attachment-file"
    >
      <Icon
        size="small"
        appearance="neutral"
        name={fileTypeIcon(attachment.mimeType)}
      />
      <Body size="sm" className={styles.fileName}>
        {attachment.fileName}
      </Body>
      <Icon
        size="small"
        appearance="neutral"
        name="Navigation-Download"
        className={styles.downloadIcon}
      />
    </Stack>
  );
}
